import {
  getLocationRootKind,
  IKindBearingLocation,
  isLocationResourceType,
  LOCATION_KIND_ROOTS,
} from '~/client/src/shared/resources/domain/locationKind'

/**
 * The bucket for a place no kind store holds: its root kind is one the project added
 * itself, or it has no kind at all (STX1-597).
 *
 * Neither a kind slug (snake_case) nor a LocationType (PascalCase), so it cannot collide
 * with a bucket either vocabulary names.
 */
export const OTHER_LOCATIONS_ROUTING_KEY = '#otherLocations'

const KNOWN_ROOTS: ReadonlySet<string> = new Set(LOCATION_KIND_ROOTS)

/**
 * The bucket a location row belongs in. The initial page and the live subscription both
 * route through this, so a row cannot be bucketed one way on load and another on update.
 *
 * - A place whose ROOT kind is one of the twelve roots goes to that root's bucket. Root,
 *   not leaf: an elevator belongs with the vertical objects. Kind rather than
 *   LocationType, because a collapsed location reports LocationType.Location and carries
 *   its kind in data.type.
 * - Any other place - a project-added root kind, or no kind at all - goes to
 *   {@link OTHER_LOCATIONS_ROUTING_KEY}. Before the catch-all these fell into buckets no
 *   store read, and vanished from every surface outside the Locations app.
 * - Everything else (equipment, sensors, materials, integrations) routes by its resource
 *   type, as it always has.
 */
export function locationRoutingKey(
  item: IKindBearingLocation | null | undefined,
): string {
  const root = getLocationRootKind(item)
  if (root && KNOWN_ROOTS.has(root)) return root

  if (isLocationResourceType(item?.type)) return OTHER_LOCATIONS_ROUTING_KEY

  return String(item?.type ?? '')
}
